import React from 'react';

import { PrimaryButton } from '@app/components/button';
import { Hr } from '@app/components/hr';
import { PURCHASE_TAB_STRINGS } from '@app/components/purchase-form/purchase-form.constants';

import { PurchaseOverlayContainer } from '../purchase-overlay-container';

const ExamDetail = ({ label, value }) => (
	<div className="detail-list__item detail-list__item--sm">
		<dt className="u-text-uppercase detail-list__title">{label}</dt>
		<dd className="detail-list__desc">{value}</dd>
	</div>
);

const ExamDetailList = ({
	labels: { examWindow, locationType, country, state, center, program },
}) => (
	<>
		{examWindow && (
			<p className="u-font-family-text course-overlay__help-text">
				Exam Window
				<strong>{examWindow}</strong>
			</p>
		)}

		<dl className="detail-list__container detail-list__container--w-divider detail-list__container--4-col">
			<ExamDetail label="Testing Location Type" value={locationType} />

			{locationType === 'On-site' && (
				<>
					<ExamDetail label="Country" value={country} />

					{state && <ExamDetail label="State" value={state} />}

					<ExamDetail label="Testing Center" value={center} />
				</>
			)}

			<ExamDetail label="Program" value={program} />
		</dl>
	</>
);

export const PurchaseExamOverlay = ({
	hasMatchingCartItem,
	isSingleForm,
	labels,
	onClose,
	onSelect,
	show,
	title,
	setContainerHeight,
	isPpaEnrollment = false,
	myCoursesUrl = '/courses-exams',
}) => (
	<PurchaseOverlayContainer
		showCartButton={!isPpaEnrollment && !hasMatchingCartItem && !isSingleForm}
		show={show}
		title={title}
		onClose={onClose}
		setContainerHeight={setContainerHeight}
		tabType={PURCHASE_TAB_STRINGS.EXAM_TAB.id}
		isPpaEnrollment={isPpaEnrollment}
		myCoursesUrl={myCoursesUrl}
	>
		<ExamDetailList labels={labels} />

		<Hr neutral />

		{isPpaEnrollment && (
			<a href={myCoursesUrl} className="btn btn--primary" title="My Courses">
				Go to My Courses
			</a>
		)}

		{!isPpaEnrollment && (hasMatchingCartItem || isSingleForm) && (
			<>
				<p>
					If you need to update this information, you can do so in the cart.
				</p>

				<a href="/cart" className="btn btn--primary" title="Cart">
					Continue to Cart
				</a>
			</>
		)}

		{!isPpaEnrollment && !hasMatchingCartItem && !isSingleForm && (
			<>
				<p className="u-font-family-text course-overlay__help-text">
					You haven&apos;t selected your course materials yet.
					<strong>Would you like to do that now?</strong>
				</p>
				<PrimaryButton onClick={onSelect}>Select Your Materials</PrimaryButton>
			</>
		)}
	</PurchaseOverlayContainer>
);
